import styled from "@emotion/styled";
import { fontMerriweather } from "@product/scmp-sdk";

import { StyledDiv } from "~/components/article/article-author-block/article-date/styles";
import { ArticleDateAndLabelContainer } from "~/components/article/article-author-block/styles";

import { NewsletterArticleBreadcrumb } from "./breadcrumb";

export const StyledNewsletterArticleBreadcrumb = styled(NewsletterArticleBreadcrumb)``;

export const AuthorBlock = styled.div`
  max-inline-size: 336px;
  margin-inline-start: auto;
  margin-inline-end: auto;
  ${ArticleDateAndLabelContainer} {
    flex-flow: column;
  }
  ${StyledDiv} {
    ${props => props.theme.breakpoints.up("tablet")} {
      min-block-size: 0;
    }
  }
`;

export const Headline = styled.div`
  margin-block-end: 60px;

  color: #000000;
  font-weight: 300;
  font-size: 30px;
  font-family: ${fontMerriweather};
  line-height: 42px;
  text-align: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 48px;
    line-height: 64px;
  }
`;

export const Navigation = styled.div`
  margin-block-end: 16px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 28px;
  }
`;
